// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p.dataDumpTerms {\n  height: 60vh;\n  overflow: scroll;\n}", "",{"version":3,"sources":["webpack://./src/pages/dataDump/DataDump.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,gBAAA;AACJ","sourcesContent":["p.dataDumpTerms {\n    height: 60vh; \n    overflow: scroll;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
